import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import Container from 'app/shared/core/Container';
import SkeletonListingCardGroup from 'app/shared/modules/skeleton/SkeletonListingCardGroup';
import FeedView from 'app/shared/modules/FeedView';
import FeedSkeletonView from 'app/shared/modules/FeedView/FeedSkeletonView';
import { useViewMode } from 'app/shared/hooks/useViewMode';
import type { RootReduxState } from 'app/shared/flux/reducers';

const AreaListingsContainer = loadable(
  () =>
    import(
      /* webpackChunkName: "AreaListingsContainer.loadable" */ 'app/shared/wrappers/AreaListingsContainer/component'
    ),
  {
    fallback: (
      <Container>
        <SkeletonListingCardGroup count={20} />
      </Container>
    ),
  },
);

type LoadableAreaListingsContainerProps = {
  maxListingsPerPage: number;
  setMapView?: () => void;
  isSkeleton?: boolean;
};

const LoadableAreaListingsContainer = (props: LoadableAreaListingsContainerProps) => {
  const [viewMode] = useViewMode();
  const listings = useSelector((state: RootReduxState) => state.listings.listingGroups.byCoords);
  const listingsLoading = useSelector((state: RootReduxState) => !state.app.fetchListingsByCoordsComplete);
  const haloHdp = useSelector((state: RootReduxState) => Boolean(state.app.haloHdp));

  if (viewMode === 'feed' && haloHdp) {
    if (listingsLoading || listings.length === 0) {
      return <FeedSkeletonView />;
    }
    return <FeedView listings={listings} />;
  }

  return <AreaListingsContainer {...props} />;
};

export default LoadableAreaListingsContainer;
